import { Action } from '@reduxjs/toolkit'

import { AppDispatch } from '@app/store/store'
import { TRANSLATIONS } from '@app/constants'

const translateError = (errorName: string): string => TRANSLATIONS.apiErrors[errorName] || TRANSLATIONS.genericError

const catchErrorHandler = (error: Error, dispatch: AppDispatch, actionFailure: (...args: unknown[]) => Action) => {
  const errorMessage = error.message

  console.error(errorMessage)

  dispatch(actionFailure({ message: translateError(errorMessage) }))
}

export default catchErrorHandler
